<template>
    <breadCrumbs title="Ribbons" main="Bonus UI" title1="Ribbons" />
    <div class="container-fluid">
        <div class="row">
            <coloredBreadcrumb />
        </div>
        <ribbons />
    </div>
</template>
<script>
import coloredBreadcrumb from "./coloredRibbons.vue"
import ribbons from "./ribbonsRight.vue"

export default {
    components: {
        coloredBreadcrumb,
        ribbons,

    }
}
</script>